import { Inject, Options, Prop, Vue, Watch } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import { AppInsights } from '@/trust-atcs-app/appInsights';
import store from '@/trust-atcs-app/store';
import { EventEmitter } from 'events';
import LoadingSpinner from '@/shared/components/loading-spinner/index.vue';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { ComplianceForm } from '@/shared/modules/typescript-trustapi-client/models';
import { FormEERData } from '@/trust-atcs-app/models/form-eer-data';

@Options({
  components: {
    LoadingSpinner,
  },
  emits: ['update:isSectionLoading', 'setFormDesc'],
  mixins: [FormatDateTimeMixin],
})
export default class FormEerOverview extends Vue {
  @Prop({ default: {} })
  private formEERData!: FormEERData;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights();
  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private loadingContent = false;
  private errorLoadingContent = false;
  private overviewContent: any = {} as any;

  private selectedFileForPreview: any = {};
  private blob: any;
  private documentURL: string = null as any;

  created(): void {
    this.loadOverviewContent();
  }

  mounted(): void {
    this.eventCtrl.on('reload-form-eer-overview-content', this.loadOverviewContent);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-form-eer-overview-content', this.loadOverviewContent);
  }

  private async loadOverviewContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.EeReportApi?.apiV2EeReportGetOverviewPost({
        complianceFormId: this.complianceFormEER.id,
        updatingKey: this.updatingKey,
      });
      this.overviewContent = resp.data.data as FormEerOverview;
      this.formEERData.overview = this.overviewContent;
      this.$emit('setFormDesc', this.$formatDateFullDate(this.overviewContent?.complianceYearEnd));
      store.dispatch('setFormUpdatingkey', this.overviewContent.updatingKey);
    } catch (err: any) {
      if (err.response.status === 400 && err.response.data?.errorCode == 10001) {
        // handle resubmit request in app.ts
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error loading overview content');
        this.errorLoadingContent = true;
      }
    } finally {
      this.loadingContent = false;
    }
  }

  get complianceFormEER(): ComplianceForm {
    return store.getters.getSelectedComplianceFormEER;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  private async downloadFile(file: any) {
    await this.apiService.FileAtcsApi?.apiV2FileAtcsGetComplianceFormFileByIdFileIdComplianceFormIdGet(
      file.id,
      this.complianceFormEER.id,
      { responseType: 'blob' },
    )
      .then((res: any) => {
        this.selectedFileForPreview.FileStream = res.data;
        this.selectedFileForPreview.ContentType = res.headers['content-type'];
        this.selectedFileForPreview.FileName = file.fileName;
        this.download();
      })
      .catch((err) => {
        this.ai.trackException('Unable to download file ' + err);
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to download file: ' + err);
      });
  }

  private download() {
    this.blob = new Blob([this.selectedFileForPreview.FileStream], { type: this.selectedFileForPreview.ContentType });
    this.documentURL = window.URL.createObjectURL(this.blob);
    const downloadLink = document.createElement('a');
    const fileName = this.selectedFileForPreview.FileName;
    downloadLink.href = this.documentURL;
    downloadLink.download = fileName as string;
    downloadLink.click();
  }
}
